import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { HiOutlineMenu } from "react-icons/hi";
import RenderBurgerMenu from "./RenderBurgerMenu";
import { signout } from "../../actions/auth.actions";
import ModalConfirm from "./ModalConfirm";

const BurgerMenu = () => {
    const [show, setShow] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);
    const user = useSelector((state) => state.auth.user);
    const dispatch = useDispatch();
    const triggerRef = useRef(null);
    const prevOverflow = useRef("");

    const logout = () => { dispatch(signout()); setShowConfirm(false); };
    const handleClose = () => setShowConfirm(false);
    const handleShow = () => setShowConfirm(true);

    const closeMenu = () => {
        setShow(false);
        requestAnimationFrame(() => {
            triggerRef.current?.blur();
            const ae = document.activeElement;
            if (ae && ae instanceof HTMLElement) ae.blur();
        });
    };

    useEffect(() => {
        if (show) { prevOverflow.current = document.documentElement.style.overflow || ""; document.documentElement.style.overflow = "hidden"; }
        else { document.documentElement.style.overflow = prevOverflow.current; }
        return () => { document.documentElement.style.overflow = prevOverflow.current; };
    }, [show]);

    useEffect(() => {
        let sx = 0, sy = 0, tracking = false;
        const ts = (e) => {
            if (show) return;
            const t = e.touches?.[0]; if (!t) return;
            if (t.clientX <= 16) { sx = t.clientX; sy = t.clientY; tracking = true; }
        };
        const tm = (e) => {
            if (!tracking || show) return;
            const t = e.touches?.[0]; if (!t) return;
            const dx = t.clientX - sx; const dy = Math.abs(t.clientY - sy);
            if (dx > 40 && dx > dy) { setShow(true); tracking = false; }
        };
        const te = () => { tracking = false; };
        window.addEventListener("touchstart", ts, { passive: true });
        window.addEventListener("touchmove", tm, { passive: true });
        window.addEventListener("touchend", te, { passive: true });
        return () => {
            window.removeEventListener("touchstart", ts);
            window.removeEventListener("touchmove", tm);
            window.removeEventListener("touchend", te);
        };
    }, [show]);

    return (
        <>
            <ModalConfirm title={"Выйти с профиля"} show={showConfirm} handleClose={handleClose} onClick={logout} />
            <div className="burgerMenu">
                <div className="burgerMenu__btn-container" onClick={() => setShow(true)}>
                    <button
                        ref={triggerRef}
                        type="button"
                        className="burgerMenu__btn"
                        aria-label="Открыть меню"
                    >
                        <HiOutlineMenu size={22} />
                    </button>
                </div>
                <RenderBurgerMenu
                    show={show}
                    user={user}
                    onRequestClose={closeMenu}
                    onRequestLogout={handleShow}
                />
            </div>
        </>
    );
};

export default BurgerMenu;
